module.exports = __webpack_public_path__ + "img/4aa7fda.svg";